import React from 'react';
import { ArticleBlockContentGridCol } from '../types/components/ArticleBlockContentGridCol';
import { FormBlock } from './FormBlock';
import { FormBlockProps } from './FormBlock.types';
import { BlockContentContext } from '../../BlockContent.utils';

export const FormSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: FormBlockProps) => (
      <ArticleBlockContentGridCol>
        <FormBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: FormBlockProps) => <FormBlock value={value} />;
};
